import React from 'react';
import PropTypes from 'prop-types';

const ToggleButton = ({
	buttons,
	activePrimaryButton,
	onClick,
	ButtonComponent,
	touched,
	entityTitle = '',
	...restProps
}) => {
	const activeButton = buttons[+!activePrimaryButton];

	const ariaLabel = `${activeButton.title} ${entityTitle}`;

	return (
		<ButtonComponent
			{...restProps}
			{...activeButton}
			onClick={onClick}
			ariaLabel={ariaLabel}
		/>
	);
};
ToggleButton.propTypes = {
	activePrimaryButton: PropTypes.bool,
	buttons: PropTypes.arrayOf(PropTypes.object).isRequired,
	ButtonComponent: PropTypes.elementType.isRequired,
	onClick: PropTypes.func,
	buttonRef: PropTypes.object,
	touched: PropTypes.bool,
	entityTitle: PropTypes.string
};

ToggleButton.defaultProps = {
	activePrimaryButton: true
};

export default ToggleButton;
